import {
  fetchSeasonalRules,
  FetchSeasonalRulesArgs,
} from './fetchSeasonalRules';

export const SEASONAL_RULES_BASE_QUERY_KEY = 'seasonal-rules';

export const seasonalRulesQuery = ({
  pageIndex,
  pageSize,
}: FetchSeasonalRulesArgs) => ({
  queryKey: [SEASONAL_RULES_BASE_QUERY_KEY, 'list', { pageIndex, pageSize }],
  queryFn: () => fetchSeasonalRules({ pageIndex, pageSize }),
  enabled: true,
});
